import Vue from 'vue';
import ApiModule from '@calvin_von/axios-api-module';
import middleWares from './middleware';

import commonApi from './modules/common.api';
import userApi from './modules/user.api';
import auditApi from './modules/audit.api';
import curriculumApi from './modules/curriculum.api';
import homeApi from './modules/home.api';
import integralApi from './modules/integral.api';
import jurisdictionApi from './modules/jurisdiction.api';
import memberApi from './modules/member.api';
import operationApi from './modules/operation.api';
import orderApi from './modules/order.api';
import restrictApi from './modules/restrict.api';
import shopTicketApi from './modules/shopTicket.api';
import statementApi from './modules/statement.api';
import storageApi from './modules/storage.api';
import financialApi from './modules/financial.api';
import ticketDeskApi from './modules/ticketDesk.api';
import totalPlatformApi from './modules/totalPlatform.api';
import changeCodeApi from './modules/change-code.api';
import operationLogApi from './modules/operation-log.api';
import wristApi from './modules/wrist.api';
import newStorageApi from './modules/new-storage.api';
import operationManagementApi from './modules/operation-management.api';
import shoredPhotoApi from './modules/stored-photo.api';
import employeeApi from './modules/employee.api';

const _domain = process.env.VUE_APP_API_URL;
// const _domain = 'http://47.99.98.250:9999';
const apiMod = new ApiModule({
    baseConfig: {
        baseURL: _domain,
        timeout: 60 * 1000, // Timeout
        withCredentials: true, // Check cross-site Access-Control
    },
    module: true,
    apiMetas: {
        common: commonApi,
        user: userApi,
        audit: auditApi,
        curriculum: curriculumApi,
        home: homeApi,
        integral: integralApi,
        jurisdiction: jurisdictionApi,
        member: memberApi,
        operation: operationApi,
        order: orderApi,
        restrict: restrictApi,
        shopTicket: shopTicketApi,
        statement: statementApi,
        storage: storageApi,
        financial: financialApi,
        ticketDesk: ticketDeskApi,
        totalPlatform: totalPlatformApi,
        changeCode: changeCodeApi,
        operationLog: operationLogApi,
        wrist: wristApi,
        newStorage: newStorageApi,
        operationManagement: operationManagementApi,
        storedPhoto: shoredPhotoApi,
        employee: employeeApi
    }
});

apiMod.registerForeRequestMiddleWare(middleWares.foreRequestMiddleWare);
apiMod.registerFallbackMiddleWare(middleWares.fallbackMiddleWare);

const apiInstance = apiMod.getInstance();
const _axios = apiMod.getAxios();
Vue.prototype.$api = apiInstance;

export default _axios;
